import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CenterInContainerDirective } from '../directives/center-in-container.directive';
import { AlertComponent } from './alert/alert.component';
import { CompareValidatorDirective } from './compare-validator.directive';
import { Alert } from './alert/alert.model';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';



@NgModule({
  declarations: [
    CenterInContainerDirective,
    AlertComponent,
    CompareValidatorDirective

  ],
  imports: [
    CommonModule,
    NgbModule,
  ],
  exports: [
    CenterInContainerDirective,
    AlertComponent,
    CompareValidatorDirective ,
    NgbModule

  ]
})
export class SharedModule { }
